export namespace SpaceConfigHelper {
  export function currentStateSuffix(currentState: ng.ui.IState): string {
    return currentState.name.split('.').slice(-1)[0];
  }

  // Currently workbook and datasource subspace use the same state string
  export function isCurrentStatePublishResult(currentState: ng.ui.IState): boolean {
    return currentStateSuffix(currentState) === 'publishresult';
  }
}
